import React from "react"
import { Button } from "buoy-core"
import styled from "styled-components"
import { colors, fontFamily, fontSize } from "buoy-theme"
import { FormattedMessage } from "react-intl"

const CountCircle = styled.div`
  font-family: ${fontFamily};
  ${fontSize("bodySmall")}
  border-radius: 50%;
  height: 22px;
  width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: solid 1px white;
  margin-left: 6px;
`

const SubmitButton = ({ onSubmit, disabled, text, count, ...props }) => (
  <Button fullWidth onClick={onSubmit} disabled={disabled} {...props}>
    <FormattedMessage
      id="interview.questions.button.submit"
      defaultMessage="Submit"
    />
    {count > 0 && <CountCircle>{count}</CountCircle>}
  </Button>
)

const SubmitOptionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin: 0 auto;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${colors.white};
  padding: 12px 16px;
  box-shadow: 0 -1px 10px ${colors.neutralLightest};

  button:first-child {
    width: 100%;
    max-width: 640px;
  }
`

const SubmitOptionsButton = ({ onSubmit, disabled, text, count, children }) => (
  <SubmitOptionsWrapper>
    <SubmitButton onSubmit={onSubmit} disabled={disabled} count={count}>
      {text || "Submit"}
    </SubmitButton>
    {children}
  </SubmitOptionsWrapper>
)

export { SubmitButton as default, SubmitOptionsButton }




// WEBPACK FOOTER //
// ./assets/interview/components/SubmitButton.js